import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Divider, IconButton, Badge } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PersonIcon from '@mui/icons-material/Person';
import { styled } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../app/store';
import { selectCartItemsCount } from '../features/products/cartSlice';

const NavButton = styled(Button)(({ theme }) => ({
  fontSize: '18px',
  fontWeight: 400,
  textTransform: 'none',
  paddingTop: '4px',
  paddingBottom: '4px',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

// New component that combines NavButton with NavLink
const NavLinkButton = styled(NavLink)(({ theme }) => ({
  textDecoration: 'none',
  color: 'inherit',
}));

export const MainNavbar = () => {
  const cartItemCount = useSelector(selectCartItemsCount);

  return (
    <AppBar position="static" sx={{
      background: 'rgb(0, 29, 61)',
      boxShadow: 'none',
      paddingX: 3
    }}>
      <Toolbar sx={{ justifyContent: 'flex-start', height: '40px !important', minHeight: '40px !important;', paddingLeft: '0px !important' }}>
        <NavLinkButton to="/personal">
          <NavButton color="inherit" sx={{ textTransform: 'none', minWidth: 'auto', pl: 0 }} size="small">Personal</NavButton>
        </NavLinkButton>
        <NavLinkButton to="/business">
          <NavButton color="inherit" sx={{ textTransform: 'none', minWidth: 'auto' }} size="small">Business</NavButton>
        </NavLinkButton>
      </Toolbar>
      <Divider sx={{ borderColor: 'rgba(255,255,255,0.3)', height: '0.5px' }} />
      <Toolbar sx={{ minHeight: '64px', pl: 0, pr: 0, paddingLeft: '0px !important', paddingRight: '0px !important', display: 'flex' }}>
        <NavLinkButton to="/">
          <Typography variant="h4" component="div" sx={{ flexGrow: 0, fontWeight: '900', color: 'white', cursor: 'pointer' }}>
            Totogi
          </Typography>
        </NavLinkButton>
        <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, justifyContent: 'center' }}>
          <NavLinkButton to="/create-magic-plan">
            <NavButton color="inherit" sx={{ textTransform: 'none' }}>Create a Magic Plan</NavButton>
          </NavLinkButton>
          <NavLinkButton to="/create-your-plan">
            <NavButton color="inherit" sx={{ textTransform: 'none' }}>Shop</NavButton>
          </NavLinkButton>
          <NavLinkButton to="/services">
            <NavButton color="inherit" sx={{ textTransform: 'none' }}>Services</NavButton>
          </NavLinkButton>
          <NavLinkButton to="/quick-pay">
            <NavButton color="inherit" sx={{ textTransform: 'none' }}>Quick Pay</NavButton>
          </NavLinkButton>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', pt: 1 }}>
          <Box sx={{ position: 'relative', display: 'inline-flex', alignItems: 'center' }}>
            {cartItemCount > 0 ? (
              <Badge badgeContent={cartItemCount} color="error">
                <NavLinkButton to="/cart">
                  <IconButton 
                    color="inherit"
                    sx={{
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      borderRadius: '50%',
                      '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                      },
                    }}
                  >
                    <ShoppingCartIcon sx={{ fontSize: '1.5rem' }} />
                  </IconButton>
                </NavLinkButton>
              </Badge>
            ) : (
              <NavLinkButton to="/cart">
                <IconButton 
                  color="inherit"
                  sx={{
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '50%',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    },
                  }}
                >
                  <ShoppingCartIcon sx={{ fontSize: '1.5rem' }} />
                </IconButton>
              </NavLinkButton>
            )}
          </Box>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <IconButton 
            color="inherit"
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '50%',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
              },
            }}
          >
            <PersonIcon sx={{ fontSize: '1.5rem' }} />
          </IconButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default MainNavbar;